import React, { useState } from "react";
import { Button } from "../../../design/button";
import {
  Alert,
  AlertActions,
  AlertDescription,
  AlertTitle,
} from "../../../design/alert";
import { useDiscoveryRequestTask } from "../../../contexts/DiscoveryRequestTaskContext";
import { useNavigate } from "react-router-dom";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void; // For controlling the alert visibility from parent component
  discoveryRequestTaskId: string;
}

const CompleteDiscoveryRequestTaskButton: React.FC<Props> = ({
  discoveryRequestTaskId,
  isOpen,
  setIsOpen,
}) => {
  const { updateDiscoveryRequestTask } = useDiscoveryRequestTask();
  const navigate = useNavigate();
  const [isCompleteing, setIsCompleteing] = useState(false);

  const handleSubmit = async () => {
    setIsCompleteing(true);
    try {
      await updateDiscoveryRequestTask(discoveryRequestTaskId, {
        status: "completed",
      });
      setIsOpen(false);
      navigate(-1); // Navigate back to the previous page after deletion
    } catch (error) {
      console.error("Error deleting discoveryRequestTask:", error);
      alert("Failed to complete discoveryRequestTask. Please try again later.");
    }
    setIsCompleteing(false);
  };

  return (
    <>
      <Alert open={isOpen} onClose={setIsOpen}>
        <AlertTitle>Mark Complete?</AlertTitle>
        <AlertDescription>
          Do you want to mark this Task as complete?
        </AlertDescription>
        <AlertActions>
          <Button
            plain
            onClick={() => setIsOpen(false)}
            disabled={isCompleteing}
          >
            Cancel
          </Button>
          <Button
            color={"green"}
            onClick={handleSubmit}
            disabled={isCompleteing}
          >
            Complete
          </Button>
        </AlertActions>
      </Alert>
    </>
  );
};

export default CompleteDiscoveryRequestTaskButton;
